import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';

const CustomP = styled('p')(() => ({
  textAlign: 'center',
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '24px',
  margin: '10px auto',
  color: '#263238',
}));

function PEnterText({
  children,
  ...props
}) {
  return (
    <CustomP {...props}>{children}</CustomP>
  );
}

PEnterText.propTypes = {
  children: PropTypes.node,
};

PEnterText.defaultProps = {
  children: null,
};

export default PEnterText;
